import $ from 'jquery';
import './maps/markerclusterer';
import Component from "../models/Component";
import {$Doc} from "../utils/jQueryGlobals";
import MapStyle from './maps/style';

export default class GoogleMaps extends Component {
  constructor(element, context) {
    super(element, context);

    this.canvas = this.element.find('.canvas');
    this.customMarkers = this.getData('markers');
    this.category = this.getData('category');
    this.markers = [];
    this.init();

    if (!GoogleMaps.initialized) {
      window.initializeGoogleMaps = () => {
        $Doc.trigger('googleMapsInit');
      };
      GoogleMaps.addGoogleMapsJs('initializeGoogleMaps', window._gTheme_.google_maps_api_key);
      GoogleMaps.initialized = true;
    }
  }

  loadMarkers() {
    const data = {action: 'get_markers'};
    if (this.customMarkers) {
      data.markers = this.customMarkers;
    }
    if (this.category) {
      data.category = this.category;
    }
    this.element.removeClass('error').addClass('loading');
    $.getJSON(window._gTheme_.ajax_url, data).done((response) => {
      if (response.returnCode && response.returnCode === 200) {
        $.each(response.returnData, (i, marker) => {
          this.markers.push(this.addMarker(marker.lat, marker.lng, marker.title, marker.text, window._gTheme_.marker_icon, true));
        });
        let styles = [];
        for (let i = 0; i < 5; i++) {
          styles.push({
            url: window._gTheme_.map_cluster_path + '3.png',
            textColor: '#ffffff',
            height: 66,
            width: 66
          });
        }
        this.mapCluster(window._gTheme_.map_cluster_path, styles);
        this.fitMarkers();
        if (this.markers.length === 1) {
          setTimeout(() => {
            google.maps.event.trigger(this.markers[0], 'click');
          }, 2000);
        }
      } else {
        this.element.addClass('error');
      }
    }).fail(() => {
      this.element.addClass('error');
    }).always(() => {
      this.element.removeClass('loading');
    });
  }

  init() {
    this.element.addClass('loading');
    $Doc.on('googleMapsInit', () => {
      this.initMap(41.909986, 12.3959157);
      this.loadMarkers();
    });
    this.element.find('.reload').on('click', () => {
      this.loadMarkers();
      return false;
    });
  }

  initMap(ltn, lng, zoom = 6, sw = false) {
    this.infowindow = null;
    this.bounds = new google.maps.LatLngBounds();
    this.map = new google.maps.Map(this.canvas.get(0), {
      zoom: zoom,
      center: new google.maps.LatLng(ltn, lng),
      scrollwheel: sw,
      styles: MapStyle,
    });
  }

  addMarker(ltn, lng, title = null, text = null, icon = null, clustered = false) {
    let marker = new google.maps.Marker({
      position: new google.maps.LatLng(ltn, lng),
      map: clustered ? null : this.map,
      title: title,
      icon: icon,
      optimized: false,
    });

    if (text) {
      marker.addListener('click', () => {
        this.openInfoWindow(text, marker);
      });
    }

    this.bounds.extend(marker.position);

    return marker;
  }

  openInfoWindow(content, marker) {
    if (this.infowindow === null) {
      this.infowindow = new google.maps.InfoWindow();
    }
    this.infowindow.close();
    this.infowindow.setContent(content);
    this.infowindow.open(this.map, marker);
  }

  mapCluster(imagePath, styles = []) {
    if (this.markers.length) {
      this.clusterer = new MarkerClusterer(this.map, this.markers, {imagePath: imagePath, styles: styles});
    }
  }

  fitMarkers() {
    if (this.markers.length > 1) {
      this.map.fitBounds(this.bounds);
      google.maps.event.addListenerOnce(this.map, 'idle', () => {
        this.clusterer.repaint();
      });
    } else if (this.markers.length > 0) {
      this.map.setCenter(this.markers[0].position);
      this.map.setZoom(10);
    }
  }

  static addGoogleMapsJs(fn, key) {
    if (typeof google === 'object' && typeof google.maps === 'object') {
      fn();
      return false;
    }
    let scriptSrc = 'https://maps.googleapis.com/maps/api/js?key=' + key + '&callback=' + fn;
    let script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = scriptSrc;
    document.body.appendChild(script);
  }
}

GoogleMaps.initialized = false;
